<script lang="ts" setup>
    import '../../../css/choice.css';
    import * as fileUtils from '../../lib/FileUtils'
    import {popAlert,ModalStyles} from '../../lib/Notification'; 
    import {onMounted,ref,reactive,computed} from 'vue';
    import {hideWindowObject} from '../../lib/Models/CommonItemsModel';   
    import WindowHeaderFooter from '../../components/WindowHeaderFooter.vue';
    import DatePickerNoTZ from '../../components/DatePickerNoTZ.vue';
    import TextInput from '../../components/TextInput.vue';
    import {NoTzDate ,getNoTzToday} from "../../lib/DateUtils" 
    import ActionButtonV2 from '../../components/ActionButtonV2.vue';
    import vSelect from 'vue-select'; 
    import {IClaimEntity,IClaim,ClaimSimpleLists} from '../../lib/Models/ClaimModel'; 
    import {ErrorReturnMessage,getWhaicReport} from '../../lib/Api/WhaicReport'; 
    import {IWhaicReportInput,IWhaicReportingData,IWhaicClaimErrors,IWhaicPatientErrors,IWhaicProviderErrors} from '../../lib/Models/Whaic837ReportModel'; 
    import ChoiceTable from "../../components/ChoiceTable.vue"; 
    import {ICol,IRowSelection, RenderModeType}  from "../../lib/ChoiceTableHelpers" ; 
    import {ButtonDisplaySize,ButtonDisplayStyle,TableRowType} from '../../Enums/UiEnums';
    import {ActionButtonStyle} from '../../lib/Types/Types';   
    import { initPinia } from '../../lib/PiniaMgr';
    import {useSimpleListStore} from '../../lib/Stores/SimpleListStore'; 
    import {openLegacyWindowFromVuew} from '../../lib/Models/CommonItemsModel';    
    
    const simpleListStore = useSimpleListStore(initPinia());
      
    const renderingProviderListLoaded = computed<boolean>(()=> {
        if (!simpleListStore) {
            return false;
        } 
        if (!simpleListStore.listResult[ClaimSimpleLists.RenderingProviders]) {
            return false;
        } 
        return true;
    }); 
    const primaryPayerListLoaded = computed<boolean>(()=> {
        if (!simpleListStore) {
            return false;
        } 
        if (!simpleListStore.listResult[ClaimSimpleLists.PrimaryPayers]) {
            return false;
        } 
        return true;
    }); 
    const serviceLocationListLoaded = computed<boolean>(()=> {
        if (!simpleListStore) {
            return false;
        } 
        if (!simpleListStore.listResult[ClaimSimpleLists.ServiceLocations]) {
            return false;
        } 
        return true;
    });  
    const saveEnabled = computed<boolean>(()=> {return (formData.ReportData.claimsProcessed > 0)})
    const claimErrorTable = ref<InstanceType<typeof ChoiceTable>>();
    const claimErrorData = ref<(IWhaicClaimErrors)[]>([]);
    const claimErrorColumns = ref<ICol[]>([ 
        { Name: 'Claim', DataField: 'claimID', RenderMode: RenderModeType.Clickable}, 
        { Name: 'Loop Name', DataField: 'errorLoopName' }, 
        { Name: 'Segment ID', DataField: 'errorSegmentID' }, 
        { Name: 'Elements', DataField: 'errorElements' }, 
        { Name: 'Subelements', DataField: 'errorSubElements' }, 
        { Name: 'Error Code', DataField: 'errorCode' }
    ]); 
    const subscriberErrorTable = ref<InstanceType<typeof ChoiceTable>>();
    const subscriberErrorData = ref<(IWhaicPatientErrors)[]>([]);
    const subscriberErrorColumns = ref<ICol[]>([ 
        { Name: 'Chart', DataField: 'patientID' , RenderMode: RenderModeType.Clickable}, 
        { Name: 'Subscriber Name', DataField: 'fullName' }, 
        { Name: 'Claims', DataField: 'claimCount' }, 
        { Name: 'Errors', DataField: 'claimErrorCount' },  
        { Name: 'Loop Name', DataField: 'errorLoopName' }, 
        { Name: 'Segment ID', DataField: 'errorSegmentID' }, 
        { Name: 'Elements', DataField: 'errorElements' }, 
        { Name: 'Subelements', DataField: 'errorSubElements' }, 
        { Name: 'Error Code', DataField: 'errorCode' }
    ]);  
    const dependentErrorTable = ref<InstanceType<typeof ChoiceTable>>();
    const dependentErrorData = ref<(IWhaicPatientErrors)[]>([]);
    const dependentErrorColumns = ref<ICol[]>([ 
        { Name: 'Chart', DataField: 'patientID', RenderMode: RenderModeType.Clickable }, 
        { Name: 'Dependent Name', DataField: 'fullName' }, 
        { Name: 'Claims', DataField: 'claimCount' }, 
        { Name: 'Errors', DataField: 'claimErrorCount' },  
        { Name: 'Loop Name', DataField: 'errorLoopName' }, 
        { Name: 'Segment ID', DataField: 'errorSegmentID' }, 
        { Name: 'Elements', DataField: 'errorElements' }, 
        { Name: 'Subelements', DataField: 'errorSubElements' }, 
        { Name: 'Error Code', DataField: 'errorCode' }
    ]);   
    const providerErrorTable = ref<InstanceType<typeof ChoiceTable>>();
    const providerErrorData = ref<(IWhaicProviderErrors)[]>([]);
    const providerErrorColumns = ref<ICol[]>([ 
        { Name: 'Provider', DataField: 'providerID' , RenderMode: RenderModeType.Clickable}, 
        { Name: 'Provider Name', DataField: 'fullName' }, 
        { Name: 'Claim', DataField: 'claimID', RenderMode: RenderModeType.Clickable }, 
        { Name: 'Loop Name', DataField: 'errorLoopName' }, 
        { Name: 'Segment ID', DataField: 'errorSegmentID' }, 
        { Name: 'Elements', DataField: 'errorElements' }, 
        { Name: 'Subelements', DataField: 'errorSubElements' }, 
        { Name: 'Error Code', DataField: 'errorCode' }
    ]); 
    const formData = reactive <
    {     
        Search: {StartDate: NoTzDate, EndDate: NoTzDate},
        ReportData: IWhaicReportingData, 
        ClaimIDs: string,
        renderingProviderIDs: Array<string>  
        serviceLocationIDs: Array<string>  
        primaryPayerIDs: Array<string>  
    }>({     
        Search: {StartDate: getNoTzToday(), EndDate: getNoTzToday()},
        ReportData: {isError: false, errorMessage: "", claimsFound: 0, claimsProcessed: 0, claimErrors: 0, fileData: ""}, 
        ClaimIDs: "",
        renderingProviderIDs: [],
        serviceLocationIDs: [],
        primaryPayerIDs: []
    });
    const props = withDefaults(defineProps<{  
        readEnabled: boolean
    }>(),
    {
        readEnabled: false,
    });
    onMounted(async () => { 
        hideWindowObject("LoadingMessage");
        simpleListStore.getSimpleLists([ClaimSimpleLists.RenderingProviders, ClaimSimpleLists.ServiceLocations, ClaimSimpleLists.PrimaryPayers]);
    });  
    
    async function getReportData() : Promise<void> { 
        const claimList : IClaim[] = [];
        if (formData.ClaimIDs.length > 0) {
            const claimIDs = formData.ClaimIDs.split(",");
            claimIDs.forEach((claimID) => {
                if (!isNaN(parseInt(claimID))) {
                    claimList.push({claimID: parseInt(claimID)});
                }
            });
        }
        const providerList : IClaimEntity[] = [];
        if (formData.renderingProviderIDs.length > 0) {
            const providerIDs = formData.renderingProviderIDs.flat();
            providerIDs.forEach((providerID) => {
                providerList.push({entityID: parseInt(providerID)});
            });
        }
        const locationList : IClaimEntity[] = [];
        if (formData.serviceLocationIDs.length > 0) {
            const locationIDs = formData.serviceLocationIDs.flat();
            locationIDs.forEach((locationID) => {
                locationList.push({entityID: parseInt(locationID)});
            });
        }
        const payerList : IClaimEntity[] = [];
        if (formData.primaryPayerIDs.length > 0) {
            const primaryPayerIDs = formData.primaryPayerIDs.flat();
            primaryPayerIDs.forEach((primaryPayerID) => {
                payerList.push({entityID: parseInt(primaryPayerID)});
            });
        }
        const reportInputs : IWhaicReportInput = {startDate: formData.Search.StartDate, endDate: formData.Search.EndDate, displayErrors: true, WhaicClaims: claimList, WhaicProviders: providerList, WhaicLocations: locationList, WhaicPayers: payerList};
        const returnResults = await getWhaicReport(reportInputs); 
        const messageTitle = "Get Report";
        if (!returnResults.success) {  
            await popAlert(returnResults.error?.error ?? ErrorReturnMessage.reportDisplay,messageTitle,ModalStyles.danger);
            return;
        } 
        claimErrorData.value = ((returnResults.success.claimErrors) ? returnResults.success.claimErrors : []);
        subscriberErrorData.value = ((returnResults.success.subscriberErrors ? returnResults.success.subscriberErrors : []));
        dependentErrorData.value = ((returnResults.success.dependentErrors ? returnResults.success.dependentErrors : []));
        providerErrorData.value = ((returnResults.success.providerErrors ? returnResults.success.providerErrors : []));
        formData.ReportData = returnResults.success.returnData;
        if (!formData.ReportData.isError) {
            formData.ReportData.errorMessage = (formData.ReportData.claimErrors == 0 ? "Data downloaded successfully." : "Downloaded data does not include all claims, due to the following errors.");
        }
    }
    function clearSearchData() : void {  
        claimErrorData.value = [];
        subscriberErrorData.value = [];
        dependentErrorData.value = [];
        providerErrorData.value = [];
        formData.ReportData = {isError: false, errorMessage: "", claimsFound: 0, claimsProcessed: 0, claimErrors: 0, fileData: ""};
    } 
    async function clearSearch() : Promise<void> { 
        clearSearchData();
        formData.ClaimIDs = "";
        formData.renderingProviderIDs = [];
        formData.serviceLocationIDs = [];
        formData.primaryPayerIDs = [];
    } 
    async function peformSearch() : Promise<void> { 
        await getReportData();
    } 
    async function exportReport() : Promise<void> { 
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
        const suggestedFileName = `Whaic837Report_${formattedDate}.txt`;

        if (!formData.ReportData.fileData) {
            return;
        }
        if ((formData.ReportData.fileData.length ?? 0) > 0) {
            await fileUtils.saveToTextFileWithPicker(formData.ReportData.fileData, suggestedFileName);
        }
    }    
    async function closeWindow() : Promise<void> {  
        window.close();
    } 
    function onCellClick(colData :  ICol,row : IRowSelection,  _rowType: TableRowType, _evt: MouseEvent) : void {
        if (colData.Name === 'Claim') {
            const data_row = <IWhaicClaimErrors|IWhaicProviderErrors> row;
            openLegacyWindowFromVuew("ClaimEntry", data_row.claimID);
            return;
        }
        else if (colData.Name === 'Chart') {
            const patient_row = <IWhaicPatientErrors> row; 
            openLegacyWindowFromVuew("PatientSetup", patient_row.patientID);
            return;
        }
        else if (colData.Name === 'Provider') {
            const provider_row = <IWhaicProviderErrors> row;
            openLegacyWindowFromVuew("Provider", provider_row.providerID);
            return;
        }
    }
      
</script> 

<style scoped>
    @import url('../../../css/Whaic837Grid.css');
</style>

<template> 
    <WindowHeaderFooter
    :headerHeight="3.5"
    :footerHeight="3.5">
        <template v-slot:WindowHeader>
            <div class="isalus-page-title-large pt-2 pb-2">WHAIC 837 Report</div>
        </template>
        <template v-slot:WindowBody>
            <div class="row label-isalus-small"> 
                <div class="grid-container-report-date-search col-4">
                    <div class="label-search-details">Date Range:</div>
                    <div>
                        <DatePickerNoTZ
                            v-model:value="formData.Search.StartDate" 
                            :clearable="false" 
                            :required=true
                            :errorDisplay=false 
                            :placeholder="'Search Start Date'"
                            :cssFramework="'vanilla'"
                            @update:value="()=>clearSearchData()" 
                        />
                    </div>  
                    <div>
                        <DatePickerNoTZ
                            v-model:value="formData.Search.EndDate" 
                            :clearable="false" 
                            :required=true
                            :errorDisplay=false 
                            :placeholder="'Search End Date'"
                            :cssFramework="'vanilla'"
                            @update:value="()=>clearSearchData()" 
                        /> 
                    </div>
                </div>     
                <div class="grid-container-report-claim-search col-8">
                    <div class="label-search-details">Claim IDs:</div>
                    <div>
                        <TextInput ref="claimTextInput" 
                            v-model:textValue="formData.ClaimIDs"
                            placeholder="Comma delimited list of Claim IDs" 
                            :required="false" 
                            :rows="1"
                            :speechToText="false"
                            title="Claim IDs"
                            @update:text-value="clearSearchData()"
                        />
                    </div>
                </div>             
            </div>    
            <div class="row label-isalus-small"> 
                <div class="grid-container-report_search col-4">
                    <div class="label-search-details details-span-3">Rendering Providers:</div>
                    <div class="label-isalus-small details-span-3" v-if="renderingProviderListLoaded">
                        <vSelect 
                            v-model="formData.renderingProviderIDs"
                            :options="simpleListStore.listResult[ClaimSimpleLists.RenderingProviders]" 
                            :reduce="item => item.value" 
                            label="description" 
                            :multiple="true" 
                            :searchable="true"
                            :filterable="true"
                            :closeOnSelect="false"
                            :select-on-tab="true"
                            @update:modelValue="clearSearchData" />
                    </div>
                </div> 
                <div class="grid-container-report_search col-4">
                    <div class="label-search-details details-span-3">Service Locations:</div>
                    <div class="label-isalus-small details-span-3" v-if="serviceLocationListLoaded">
                        <vSelect 
                            v-model="formData.serviceLocationIDs"
                            :options="simpleListStore.listResult[ClaimSimpleLists.ServiceLocations]" 
                            :reduce="item => item.value" 
                            label="description" 
                            :multiple="true" 
                            :searchable="true"
                            :filterable="true"
                            :closeOnSelect="false"
                            :select-on-tab="true"
                            @update:modelValue="clearSearchData" />
                    </div>
                </div>  
                <div class="grid-container-report_search col-4">
                    <div class="label-search-details details-span-3">Primary Payers:</div> 
                    <div class="label-isalus-small details-span-3" v-if="primaryPayerListLoaded">
                        <vSelect 
                            v-model="formData.primaryPayerIDs"
                            :options="simpleListStore.listResult[ClaimSimpleLists.PrimaryPayers]" 
                            :reduce="item => item.value" 
                            label="description" 
                            :multiple="true" 
                            :searchable="true"
                            :filterable="true"
                            :closeOnSelect="false"
                            :select-on-tab="true"
                            @update:modelValue="clearSearchData" />
                    </div>
                </div>
            </div>
            <div class="row label-isalus-small pt-2"> 
                <div class="grid-container-report-data col-12" style="border-top: 1px solid silver">
                    <div class="label-search-details">Total:</div>
                    <div class="label-search-details" title="Number of claims found">{{formData.ReportData.claimsFound}}</div>
                    <div class="label-search-details">Processed:</div>
                    <div class="label-search-details" title="Number of claims processed">{{formData.ReportData.claimsProcessed}}</div>
                    <div class="label-search-details">Error:</div>
                    <div class="label-search-details" title="Number of claims in error">{{formData.ReportData.claimErrors}}</div>
                    <div class="label-search-details">Message:</div>
                    <div class="label-search-details">{{formData.ReportData.errorMessage}}</div>
                </div>
            </div>
            <p v-if="claimErrorData.length > 0" style="font-size: .75rem;" class="pt-2">
                <ChoiceTable 
                    ref="claimErrorTable"
                    :columns="claimErrorColumns" 
                    :data="claimErrorData" 
                    :show-filters="false" 
                    :show-footer="false" 
                    :allowSorting="true"
                    :key-value-data-member="'claimID'"
                    @cellclick="onCellClick">
                </ChoiceTable>
            </p>
            <p v-if="subscriberErrorData.length > 0" style="font-size: .75rem;" class="pt-2">
                <ChoiceTable 
                    ref="subscriberErrorTable"
                    :columns="subscriberErrorColumns" 
                    :data="subscriberErrorData" 
                    :show-filters="false" 
                    :show-footer="false" 
                    :allowSorting="true"
                    :key-value-data-member="'patientID'"
                    @cellclick="onCellClick">
                </ChoiceTable>
            </p>
            <p v-if="dependentErrorData.length > 0" style="font-size: .75rem;" class="pt-2">
                <ChoiceTable 
                    ref="dependentErrorTable"
                    :columns="dependentErrorColumns" 
                    :data="dependentErrorData" 
                    :show-filters="false" 
                    :show-footer="false" 
                    :allowSorting="true"
                    :key-value-data-member="'patientID'"
                    @cellclick="onCellClick">
                </ChoiceTable>
            </p>
            <p v-if="providerErrorData.length > 0" style="font-size: .75rem;" class="pt-2">
                <ChoiceTable 
                    ref="providerErrorTable"
                    :columns="providerErrorColumns" 
                    :data="providerErrorData" 
                    :show-filters="false" 
                    :show-footer="false" 
                    :allowSorting="true"
                    :key-value-data-member="'providerID'"
                    @cellclick="onCellClick">
                </ChoiceTable>
            </p>
        </template>
        <template v-slot:WindowFooter>
            <div class="text-end ">
                <ActionButtonV2 
                    :action="ActionButtonStyle.Erase"
                    :text="'Clear'" 
                    :tooltip="'Clear search criteria and results - leaving date range alone.'"
                    :size="ButtonDisplaySize.Small" 
                    :displayStyle="ButtonDisplayStyle.OutlinePrimary"  
                    :performAction="clearSearch"
                    :endingPadding="1"/> 
                <ActionButtonV2 
                    :action="ActionButtonStyle.Search"
                    :text="'Search'"
                    :spinText="'Searching...'"
                    :tooltip="'Search for claims'"
                    :size="ButtonDisplaySize.Small" 
                    :displayStyle="ButtonDisplayStyle.OutlinePrimary"  
                    :performAction="peformSearch"
                    :endingPadding="1"/> 
                <ActionButtonV2 
                    :action="ActionButtonStyle.Export"
                    :text="'Export'"
                    :spinText="'Exporting...'"
                    :tooltip="'Export report data to a file'"
                    :disabled="!saveEnabled"
                    :size="ButtonDisplaySize.Small" 
                    :displayStyle="ButtonDisplayStyle.OutlinePrimary"  
                    :performAction="exportReport"
                    :endingPadding="1"/> 
                <ActionButtonV2 
                    :action="ActionButtonStyle.Close"
                    :text="'Close'"
                    :size="ButtonDisplaySize.Small" 
                    :displayStyle="ButtonDisplayStyle.OutlinePrimary"  
                    :performAction="closeWindow"/> 
            </div>
        </template>
    </WindowHeaderFooter> 
</template>
